import axios from '../../../helpers/axios-setup';
import { FormCapability } from '../../../components/pages/certification/types';

export const updateCertifcationCapabilities = (id: number, data: FormCapability[]) =>
  axios.patch(`/certifications/capabilities/${id}`, data);
